import { Injectable, SkipSelf } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/env.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { ApiEndPointsNotification } from 'src/app/services/commonUtility/apiUrls/api-end-points-notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private baseTransUrl:any;
  _content: string;
  constructor(
    @SkipSelf() private _http: HttpClient,
    private apiAddress: ApiEndPointsNotification,
    public env: EnvService,
    private constant: Constants
  ) {

    
    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseTransUrl = this.constant.ManageTranscationportNumber;
else
    this.baseTransUrl = this.env.apiUrl+this.constant.ManageTranscationportNumber;
   
  }

 
  // To get Notification List
  getNotificationList(data: any): Observable<any> {
    const apiURL = this.baseTransUrl + this.apiAddress.NotificationList;
    //return this._http.post(apiURL, data).pipe();
    return new Observable<Object>();
  }
  
  // To get Unread Notification count
  GetUnreadNotificationsCount(data: any): Observable<any> {
  const apiURL = this.baseTransUrl + this.apiAddress.GetUnreadNotificationsCount;
  //return this._http.post(apiURL, data).pipe();
  return new Observable<Object>();
  }

  // MarkUnreadNotifications
  MarkUnreadNotifications(data: any): Observable<any> {
    const apiURL = this.baseTransUrl + this.apiAddress.MarkUnreadNotifications;
    //return this._http.post(apiURL, data).pipe();
    return new Observable<Object>();
  }
  
}
